import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Snackbar from '@mui/material/Snackbar';
import Alert from '../../components/Alert';
import Loader from '../../components/Loader/Loader';
import api from '../../services/api';
import { OKTA_AUTH_TOKENS } from '../../constants/api';
import { setLoggedInViaSSO } from '../../modules/reducer/authSlice';
import { useDispatch } from 'react-redux';
import { LOCAL_STORAGE_AUTH_NAME } from '../../constants/utils';
import { ROUTES } from '../../constants/routes';

const OktaLogin = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [alertSeverity, setAlertSeverity] = useState('success');
  const urlParams = new URLSearchParams(window.location.search);
  const code = urlParams.get('code');
  const transactionStorage = JSON.parse(sessionStorage.getItem('okta-transaction-storage'));
  let codeVerifier = '';
  if (transactionStorage && transactionStorage.codeVerifier) {
    codeVerifier = transactionStorage.codeVerifier;
  }
  const isEffectRun = useRef(false);

  async function getTokens(code, codeVerifier) {
    try {
      const payload = {
        code: code,
        code_verifier: codeVerifier,
      };
      const response = await api.post(OKTA_AUTH_TOKENS, payload);
      if (response?.data?.access && response?.data?.refresh) {
        localStorage.setItem(LOCAL_STORAGE_AUTH_NAME, JSON.stringify(response.data));
        dispatch(setLoggedInViaSSO(response.data));
      }
      setTimeout(() => navigate(ROUTES.dashboard), 1000);
    } catch (error) {
      setSnackbarMessage('Something went wrong');
      setAlertSeverity('error');
      navigate(ROUTES.login);
      console.error(error);
    }
  }

  useEffect(() => {
    if (!isEffectRun.current && codeVerifier?.length && code?.length) {
      getTokens(code, codeVerifier);
      isEffectRun.current = true;
    }
  }, [codeVerifier, code]);
  const handleCloseSnackBar = () => {
    setSnackbarOpen(false);
  };

  useEffect(() => {
    if (snackbarOpen) {
      const snackbarTimeout = setTimeout(() => {
        handleCloseSnackBar();
      }, 3000);

      return () => {
        clearTimeout(snackbarTimeout);
      };
    }
  }, [snackbarOpen]);
  return (
    <div style={{ height: '100%' }}>
      <Loader message={'Logging in...'} />
      <Snackbar
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        open={snackbarOpen}
        autoHideDuration={3000}
      >
        <Alert severity={alertSeverity}>{snackbarMessage}</Alert>
      </Snackbar>
    </div>
  );
};

export default OktaLogin;
